import { connect } from "react-redux";

import { reducer, mapStateToProps, mapDispatchToProps } from "./ProfilePage.state";
import ProfilePage from "./ProfilePage";

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);

export { reducer, mapStateToProps, mapDispatchToProps };
